import Vue from "vue";
import Vuex from "vuex";
import VueRouter from "vue-router";
import Axios from "axios";
import noUiSlider from "noUiSlider";
import JSZip from "jszip";
import JSZipUtils from "jszip-utils";
import FileSaver from "file-saver";
import { Loader } from "@googlemaps/js-api-loader";
import { Fancybox } from "@fancyapps/ui";

(<any>window).Vue = Vue;
(<any>window).Vuex = Vuex;
(<any>window).VueRouter = VueRouter;
(<any>window).Axios = Axios;
(<any>window).noUiSlider = noUiSlider;
(<any>window).JSZip = JSZip;
(<any>window).JSZipUtils = JSZipUtils;
(<any>window).FileSaver = FileSaver;
(<any>window).Loader = Loader;
(<any>window).Fancybox = Fancybox;